exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-block {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n.ic-block__header {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n    -ms-flex-align: center;\n        align-items: center;\n    padding: 8px;\n}\n.ic-block__title {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    font-size: 18px;\n    color: #526069;\n    font-weight: 300;\n}\n.ic-block__line {\n    -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n    height: 1px;\n    background: rgba(0, 0, 0, .24);\n    margin-left: 8px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/block/block.component.css
// module id = ../../../../../src/app/layout/block/block.component.css
// module chunks = 3